import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import history from './routes/history';
import PrivateRoute from './routes/PrivateRoute';

import * as pages from './crew/pages';

export default class App extends React.Component {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <Router history={history}>
        <div id="CrewApp" className="w-full h-full absolute">
          <Switch>
            {/* Public Routes */}
            <Route path="/crew/login" component={pages.Login} />

            {/* Private Routes */}
            <PrivateRoute path="/crew" exact component={pages.Home} loginUrl="/crew/login" />
            <PrivateRoute
              path="/crew/schedule/:staff/:date?"
              component={pages.MainPage}
              loginUrl="/crew/login"
            />
          </Switch>
          <div id="AlertsArea" />
        </div>
      </Router>
    );
  }
}
